<script setup lang="ts"></script>

<template>
  <div class="setting-button cursor-pointer">
    <v-icon icon="$mdiCogOutline" :size="20" />
  </div>
</template>

<style lang="scss" scoped>
  .setting-button {
    color: white;
    border-radius: 15px;
    height: 30px;
    padding: 2px 12px;
    font-size: 10px;
    font-weight: 700;
    line-height: 24px; // アイコンがズレるので個別に指定
    background-color: rgb(var(--v-theme-monochrome-03));
  }
</style>
